import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "procedure-summary" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-4 mb-2" }, "Approval Criteria Information", -1)
const _hoisted_4 = { class: "border-l-4 pl-4 text-sm text-gray-600 whitespace-pre-wrap" }
const _hoisted_5 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryProperty = _resolveComponent("SummaryProperty")!
  const _component_Recommendation = _resolveComponent("Recommendation")!
  const _component_ProcedureCriteria = _resolveComponent("ProcedureCriteria")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.procedure.policyId)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 0,
          class: "policy-id",
          name: "Policy ID"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.procedure.policyId) + " ", 1),
            (_ctx.procedure.policyUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "policy-url text-blue-800",
                  href: _ctx.procedure.policyUrl,
                  target: "_blank"
                }, "(source)", 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.procedure.policyName)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 1,
          class: "policy-name",
          name: "Policy Name",
          value: _ctx.procedure.policyName
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SummaryProperty, {
      class: "recommendation-status",
      name: "Recommendation"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Recommendation, {
          status: _ctx.procedure.recommendationStatus
        }, null, 8, ["status"])
      ]),
      _: 1
    }),
    (_ctx.procedure.recommendationStatusReason != null)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 2,
          class: "recommendation-status",
          name: "Recommendation Reason"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Recommendation, {
              status: _ctx.procedure.recommendationStatusReason
            }, null, 8, ["status"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.historical)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 3,
          class: "recommendation-status",
          name: "Clinical Review"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Recommendation, {
              status: _ctx.formatApproval(_ctx.procedure.approved)
            }, null, 8, ["status"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.clinicalReview != null)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 4,
          class: "clinical-review",
          name: "Clinical Review"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Recommendation, { status: _ctx.clinicalReviewText }, null, 8, ["status"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.procedure.approvalFrequencyType && _ctx.procedure.approvalFrequencyValue)
      ? (_openBlock(), _createBlock(_component_SummaryProperty, {
          key: 5,
          class: "frequency",
          name: "Frequency",
          value: _ctx.formatFrequency(_ctx.procedure)
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.approvalCriteria)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          _hoisted_3,
          _createElementVNode("blockquote", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.approvalCriteria.name), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.approvalCriteria.detail), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "toggle-criteria cursor-pointer mt-4 text-sm text-blue-800",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOtherCriteria && _ctx.toggleOtherCriteria(...args)))
    }, " Show Other Criteria "),
    _createVNode(_component_Modal, {
      active: _ctx.showOtherCriteria,
      "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showOtherCriteria) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ProcedureCriteria, {
          onReview: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showOtherCriteria = false)),
          procedure: _ctx.procedure,
          "procedure-index": _ctx.procedureIndex,
          criteria: _ctx.otherCriteria,
          historical: _ctx.historical,
          style: {"height":"90vh","width":"95vw"}
        }, null, 8, ["procedure", "procedure-index", "criteria", "historical"])
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}